import React from 'react';
import Reflux from 'reflux';
import {Form, Button, Row, Col, Modal, Radio, Input, Select, message} from 'antd';

const RadioGroup = Radio.Group;
const Option = Select.Option;
import {hashHistory} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice} from 'Utils';
import {customerList, getPro, fetchChannelList, fetchChannelList2} from '../../service/shoppingCar';
import {getGouXiaoUnitList} from "../../service/traceOrder";
/*客户名称,购货单位,渠道,订单类型接口*/
const FormItem = Form.Item;

class ShoppingCarAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.channelCode = this.channelData.split('|')[1] || '';
        let obj = {}
        if (props.params.id == 5) {
            obj = {
                dingZhi: props.params.customer,
                thirdId: props.params.cusId,
                cusId: props.params.cusId,
                customerName: props.params.customer,
                userId: props.params.userId,
            }
        }
        this.state = {
            opts: ['生成订单'],
            channelCode: this.channelCode,
            visible: false,
            disabledSet: props.params.id != 5 && props.params.id != 4,//true,
            alreadyRows: [],
            alreadyTotal: 1,
            selectedRowKeys: [],
            name: '',
            code: '',
            alreadySearchObj: {
                channelCode: this.channelData.split('|')[1] || '',
                fatherId: '',
                s: 10,
                p: 1
            },
            options1: [],
            options2: [],
            options3: {
                ordinaryOrderFlag: 'N',
                terminalOrderFlag: 'N',
                vipOrderFlag: 'N',
            },
            thirdId: '',    //传入购货单位的ID
            thirdIdName: this.props.params.id == 5 ? this.props.params.customer : "请选择客户名称",
            purchaseName: '',
            payment: '',
            channel_GouHuo: [],
            value1: this.channelData.split('|')[0] || '',
            detail: {},
            nextVisible: this.channelCode == 'ALL',
            loadding: false,
            xId: props.params.id || undefined,
            ...obj
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.addSaveHandler = this.addSaveHandler.bind(this);
    };

    /*获取列表数据*/
    initData() {
    }

    // componentWillMount() {
    //     let self = this;
    //     // if (this.props.params.id == 5 || this.props.params.id == 4) {
    //     //     this.setState({disabledSet: false})
    //     // }
    //     // if (this.state.channelCode == 'ALL') {
    //     //     openNotice('warning', '请确认渠道');
    //     //     self.setState({nextVisible: true});
    //     // }
    //     // if (this.props.params.id == 5) {
    //     //     this.setState({
    //     //         dingZhi: this.props.params.customer,
    //     //         thirdId: this.props.params.cusId,
    //     //         cusId: this.props.params.cusId,
    //     //         customerName: this.props.params.customer,
    //     //         userId: this.props.params.userId,
    //     //     })
    //     // }
    //     const {channelCode} = this.state;
    //     customerList(channelCode).then(res => { //人员
    //         self.setState({
    //             options1: res.data,
    //         });
    //         // debugger
    //         if (res.data.length == 1 && res.data[0].thirdId && res.data[0].name) {
    //             this.setState({
    //                 thirdId: res.data[0].thirdId,
    //                 cusId: res.data[0].thirdId,
    //                 thirdIdName: res.data[0].name
    //             }, () => this.getAlreadyArray2());
    //             if (res.data[0].orderSubmit == false) {
    //                 self.setState({orders: 1})
    //             } else {
    //                 self.setState({orders: 0})
    //             }
    //
    //         }
    //     });
    //     // var x = window.sessionStorage.getItem('cur_channel').split('|')[0]
    //     fetchChannelList().then(res => { //渠道
    //         if (res && res.code == 200) {
    //             if (res.data.length > 0) {
    //                 self.setState({options2: res.data})
    //             } else {
    //                 self.setState({options2: ''})
    //             }
    //         }
    //     });
    //     // var xId = this.props.params.id;
    //     // this.setState({xId: xId});
    // };

    componentDidMount() {
        let self = this;
        const {channelCode} = this.state;
        customerList(channelCode).then(res => { //人员
            self.setState({
                options1: res.data,
            });
            // debugger
            if (res.data.length == 1 && res.data[0].thirdId && res.data[0].name) {
                this.setState({
                        thirdId: res.data[0].thirdId,
                        cusId: res.data[0].thirdId,
                        thirdIdName: res.data[0].name
                    }, () => {
                        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //渠道
                            if (res.status) {
                                let arr = [];
                                res.data.forEach(x => {
                                    arr.push({
                                        text: x.name,
                                        value: x.name
                                    })
                                });
                                self.setState({channel_GouHuo: arr}, () => {
                                        if (arr.length == 1) {
                                            this.setState({
                                                name: arr[0].text
                                            }, () => {
                                                this.getAlreadyArray();
                                            });
                                        }
                                    }
                                )
                            }
                        });
                    }
                );
                if (res.data[0].orderSubmit == false) {
                    self.setState({orders: 1})
                } else {
                    self.setState({orders: 0})
                }

            }
        });
        fetchChannelList().then(res => { //渠道
            if (res && res.code == 200) {
                if (res.data.length > 0) {
                    self.setState({options2: res.data})
                } else {
                    self.setState({options2: ''})
                }
            }
        });

        this.initData();
        // debugger
        // console.log(this.state)
        this.setState({
            channelCode2: this.state.channelCode
        })
        this.getNav();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*客户名称选中*/
    cusNameChange(value) {
        const self = this;
        // console.log('Selected area id is: ' + value);
        let messages = this.state.options1.filter(x => x.thirdId == value)[0];
        // console.log(messages.orderSubmit);
        // debugger
        if (messages.orderSubmit == false) {
            self.setState({orders: 1})
        } else {
            self.setState({orders: 0})
        }
        this.setState({
            thirdId: value
        });
    }

    getNav() {
        var explorer = window.navigator.userAgent;
        console.log(explorer);
        if (explorer.indexOf("MSIE") >= 0) {
        } else if (explorer.indexOf("Firefox") >= 0) {
            Modal.warning({
                title: "注意",
                content: "强烈推荐使用‘谷歌、360、搜狗’等浏览器，因为使用“火狐浏览器”可能会出现一些未知的错误，所以请尽快更换浏览器。（360、搜狗需要开启极速模式）"
            });
        } else if (explorer.indexOf("Opera") >= 0) {
        } else if (explorer.indexOf("Chrome") >= 0) {
        }
    }


    /*购货单位选择弹窗*/
    searchHandler = (event) => {
        this.setState({visible: true});
        //this.getAlreadyArray();
    };
    onSelectId = (record, selected, selectedRows) => {
        // console.log(record)
        // console.log(selected)
        // console.log(selectedRows)
        var selectedRowKeys = [];
        selectedRowKeys = selectedRows;
        // debugger
        // console.log(selectedRowKeys);

        this.setState({
            // selectedRowKeys: selectedRowKeys,
            purchaseId: record.purchaseId
        });
    };
    /*购货单位选择列*/
    onSelectChange = (selectedRowKeys, item) => {
        // console.log(item);
        //      debugger
        this.setState({
            selectedRowKeys,
            item
        });
    };
    /*购货单位列表翻页*/
    alreadyPageChange = (page, pageSize) => {
        this.setState({alreadySearchObj: {...this.state.alreadySearchObj, s: pageSize, p: page}}, function () {
            this.getAlreadyArray();
        });
    };
    /*购货单位名称搜索*/
    nameChange = (event) => {
        console.log(event);
        this.setState({
            //name: event.target.value
            name: event
        }, () => {
            this.getAlreadyArray();
        });
    };
    /*购货单位项目名称搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    };
    /*购货单位选择列表数据(点击搜索)*/

    getAlreadyArray = () => {
        const self = this;
        // console.log(this.state.thirdId);

        if (this.state.thirdId === '') {
            openNotice('warning', '请先选择客户名称');
            this.setState({visible: false});
            return;
        }

        if (this.state.name === '') {
            openNotice('warning', '请先输入购货单位名称再做查询！');
            //this.setState({visible: false});
            return;
        }
        var type = '';
        if (self.props.params.id == 1) {
            type = 1;
        }
        ;
        if (self.props.params.id == 2) {
            type = 2;
        }
        ;
        if (self.props.params.id == 3) {
            type = 3;
        }
        ;
        this.setState({loadding: true});
        getPro({
            purchaseName: this.state.name,
            payment: this.state.code,
            customerId: this.state.thirdId,
            channelCode: this.state.alreadySearchObj.channelCode,
            p: this.state.alreadySearchObj.p,
            s: this.state.alreadySearchObj.s,
            type: type
        }).then(result => {
            if (result.status) {
                this.setState({
                    alreadyRows: result.data,
                    // channelCode: result.data.channelCode,
                    alreadyTotal: result.total,
                    loadding: false
                });
            } else {
                message.error(result.message);
            }
        });
        this.setState({
            alreadySearchObj: {
                ...this.state.alreadySearchObj,
                fatherId: this.fatherId,
            }
        });
    };

    getAlreadyArray2 = () => {
        const self = this;
        if (this.state.thirdId === '') {
            openNotice('warning', '请先选择客户名称');
            this.setState({visible: false});
            return;
        }
        var type = '';
        if (self.props.params.id == 1) {
            type = 1;
        }

        if (self.props.params.id == 2) {
            type = 2;
        }

        if (self.props.params.id == 3) {
            type = 3;
        }
        getPro({
            purchaseName: this.state.name,
            payment: this.state.code,
            customerId: this.state.thirdId,
            channelCode: this.state.alreadySearchObj.channelCode,
            p: this.state.alreadySearchObj.p,
            s: this.state.alreadySearchObj.s,
            type: type
        }).then(result => {
            if (result.status) {
                this.setState({
                    alreadyRows: result.data,
                    alreadyTotal: result.total,
                    loadding: false
                }, () => {
                    if (result.data.length == 1) {
                        this.setState({
                            purchaseId: result.data.purchaseId,
                            item: result.data,
                            selectedRowKeys: 0
                        }, () => this.addSaveHandler())
                    }
                });
            } else {
                message.error(result.message);
            }
        });
        this.setState({
            alreadySearchObj: {
                ...this.state.alreadySearchObj,
                fatherId: this.fatherId,
            }
        });
    };

    /*点击确定保存*/
    addSaveHandler = () => {
        if (this.state.selectedRowKeys.length == 0) {
            openNotice('warning', '请选择购货单位');
            return;
        }
        // console.log(this.state.item[0].name);
        let purchaseName = this.state.item[0].purchaseName;
        let defDiscount = this.state.item[0].defDiscount;
        let discountAmount = this.state.item[0].discountAmount;
        let sxeAmount = this.state.item[0].sxeAmount;
        let purchaseId = this.state.item[0].purchaseId;
        let pay = this.state.item[0].pay;
        let paymentTermId = this.state.item[0].paymentTermId;
        let taxTypeCode = this.state.item[0].taxTypeCode;
        let deliveryShowprice = this.state.item[0].deliveryShowprice;
        let selectEscrowFlag = this.state.item[0].selectEscrowFlag;
        window.sessionStorage.setItem('purchaseId', JSON.stringify(purchaseId));
        this.setState({
            purchaseId: purchaseId,
            purchaseName: purchaseName,
            defDiscount: defDiscount,
            sxeAmount: sxeAmount,
            discountAmount: discountAmount,
            pay: pay,
            paymentTermId: paymentTermId,
            taxTypeCode: taxTypeCode,
            deliveryShowprice: deliveryShowprice,
            selectEscrowFlag: selectEscrowFlag,
            visible: false,
        });
        fetchChannelList2(purchaseId).then(res => { //订单类型
            if (res && res.code == 200) {
                this.setState({options3: res.data})
            }
        })
    };
    //    addSaveHandler( ){
    // 	if (this.state.selectedRowKeys.length == 0) {
    // 		openNotice('warning', '请选择购货单位');
    // 		return;
    // 	}
    // 	let purchaseName = this.state.item[0].purchaseName;
    // 	let purchaseId = this.state.item[0].purchaseId;
    // 	// console.log(purchaseName);
    // 	// console.log(purchaseId);
    // 	window.sessionStorage.setItem('purchaseId', JSON.stringify(purchaseId));
    // 	this.setState({
    // 		purchaseName: purchaseName,
    // 		visible: false,
    // 	});
    // };
    // /*渠道选中*/
    // onChangeChannel = (e) => {
    //     console.log('radio checked', e.target.value);
    //     this.setState({
    //         value1: e.target.value,
    //     });
    // };
    // /*订单类型选中*/
    // onChangeType = (e) => {
    //     console.log('radio checked', e.target.value);
    //     this.setState({
    //         value2: e.target.value,
    //     });
    // };


    /*渠道选中*/
    onChangeChannel = (e) => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value1: e.target.value,
        });
    };
    /*订单类型选中*/
    onChangeType = (e) => {
        // console.log('radio checked', e.target.value);
        // debugger
        this.setState({
            value2: e.target.value,
        });
    };

    /*取消*/
    cancelHandle() {
        hashHistory.goBack()
    }

    /*保存*/
    submitHandle() {
        const self = this;
        if (this.state.selectedRowKeys.length == 0) {
            openNotice('warning', '请选择购货单位');
            return;
        }
        // console.log(self.state.orders)
        // debugger

        const {validateFields, getFieldsValue} = this.props.form;
        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue() //获取用户输入
            };
            data.id = this.state.purchaseId;
            data.thirdId = this.state.thirdId || 0;
            // debugger
            data.defDiscount = this.state.defDiscount || 0;
            data.discountAmount = this.state.discountAmount || 0;
            data.channelCode = this.state.channelCode2 || 0;
            data.sxeAmount = this.state.sxeAmount || 0;
            data.pay = this.state.pay || 0;
            data.cusName = this.state.thirdId;
            data.paymentTermId = this.state.paymentTermId || 0;
            data.taxTypeCode = this.state.taxTypeCode || 0;
            data.deliveryShowprice = this.state.deliveryShowprice || 0;
            data.channelCode = this.state.channelCode || '';
            data.selectEscrowFlag = this.state.selectEscrowFlag || 'N';
            data.escrowFlag = this.state.selectEscrowFlag == 'Y' ? 1 : 0;

            if (this.props.params.id == 5) {
                data.cusName = this.state.cusId;
            }
            // data.thirdId2 = this.state. || 0 ;
            // console.log(this.state);
            // console.log(this.props.form)
            // debugger
            data.purchaseName = self.state.purchaseName;
            // data.sxeAmount = this.state.alreadyRows[0].sxeAmount;
            // console.log(data)
            if (self.state.orders && self.state.orders == 1) {
                // debugger
                data.orders = 1;
            }
            if (data.Type != 'Y1' && data.Type != 'Y2' && data.Type != 'Y3') {
                openNotice('warning', '请确认订单类型');
                return
            }
            // console.log(`你正在提交数据：${JSON.stringify(data)}`);
            window.sessionStorage.setItem('generate_orders', JSON.stringify(data));
            self.goView('order/addConventional')
            if (this.props.params.id != 4 || this.props.params.id != 5) {
                if (self.state.xId == '1' || self.state.xId == '2' || self.state.xId == '3') {
                    if (self.state.xId == '1' && self.state.options3.ordinaryOrderFlag == 'Y') {
                        self.goView('order/addConventional')
                    } else if (self.state.xId == '2' && self.state.options3.terminalOrderFlag == 'Y') {
                        self.goView('order/addProject')
                    } else if (self.state.xId == '3' && self.state.options3.vipOrderFlag == 'Y') {
                        self.goView('order/addPartners')
                    } else {
                        openNotice('warning', '请确认订单类型');
                    }
                }
            }
            if (this.props.params.id == 4) {
                // console.log(record)
                // debugger
                // console.log(selected)
                // console.log(selectedRows)
                var a = 4;
                if (this.state.value2 == 'Y1') {
                    self.goView(`order/addConventional/${a}`)
                }
                if (this.state.value2 == 'Y2') {
                    self.goView(`order/addProject/${a}`)
                }
                if (this.state.value2 == 'Y3') {
                    self.goView(`order/addPartners/${a}`)
                }
            }
            if (this.props.params.id == 5) {
                // console.log(record)
                // debugger
                // console.log(selected)
                // console.log(selectedRows)
                var a = 5;
                if (this.state.value2 == 'Y1') {
                    self.goView(`order/addConventional/${a}`)
                }
                if (this.state.value2 == 'Y2') {
                    self.goView(`order/addProject/${a}`)
                }
                if (this.state.value2 == 'Y3') {
                    self.goView(`order/addPartners/${a}`)
                }
            }

        })
    }

    handleOk = () => {
        this.setState({visible: false});
    };
    handleCancel = () => {
        this.setState({visible: false});
    };

    onSelectRow(record, index, event) {
        // console.log(record);
        // console.log(index);
        // console.log(event);
        // debugger
        // this.setState({
        // 	selectedRowKeys,
        // 	item
        // });
        // this.setState({selectedRows:[],selectedRowKeys:[]})

        var selectedRowKeys = [...this.state.selectedRowKeys];
        var item = [];
        selectedRowKeys[0] = record.purchaseId;
        item[0] = record;
        this.setState({
            // selectedRowKeys: selectedRowKeys,
            purchaseId: record.purchaseId,
            item: item,
            selectedRowKeys: selectedRowKeys,
        }, () => this.addSaveHandler())
    }

    render() {
        const {
            opts,
            visible,
            alreadyTotal,
            alreadySearchObj,
            alreadyRows,
            selectedRowKeys,
            options1,
            options2,
            options3,
            detail,
            purchaseName,
            value1,
            xId,
            dingZhi,
            disabledSet,
            thirdIdName,
            nextVisible,
            loadding,
            channel_GouHuo
        } = this.state;
        const styleObj = {left: 375, top: 8, zIndex: 10, position: 'absolute', cursor: 'pointer'};
        const alreadyProps = {
            rowKey: 'purchaseId',
            loading: loadding,
            pageParam: {
                total: alreadyTotal,
                current: alreadySearchObj.p,//当前页码
                pageSize: alreadySearchObj.s,//当前分页数
                onChange: this.alreadyPageChange
            },
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'purchaseId'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '付款方式',
                    dataIndex: 'pay'
                },
                /*  {
                      title: '项目编号',
                      dataIndex: 'code'
                  },
                  {
                      title: '项目名称',
                      dataIndex: 'channelName'
                  },
               */   {
                    title: '可用额',
                    dataIndex: 'sxeAmount'
                },
                /*                    {
                                        title: '签约单位',
                                        dataIndex: 'minPackageQuantity'
                                    },*/
                {
                    title: '是否折扣',
                    dataIndex: 'discountFlag',
                    render: (text) => {
                        if (text == 'Y') {
                            return '是'
                        } else {
                            return '否'
                        }
                    }
                },
                {
                    title: '折扣池可折余额',
                    dataIndex: 'discountAmount'
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName'
                },
                {
                    title: '签约类型',
                    dataIndex: 'taxType'
                },
            ],
            rows: alreadyRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                onSelect: this.onSelectId,
                onRowClick: this.onSelectRow,
                type: 'radio'
            }*/
        };

        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 4},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 20},
            },
        };
        const FormItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 2},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 22},
            },
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={0}>
                <Button type='primary' onClick={this.submitHandle.bind(this)} disabled={nextVisible}>下一步</Button>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
            </DmsTab>

            <div className="dms-table-box" style={{paddingTop: 30}}>

                <Form layout="horizontal">
                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="客户名称" {...formItemLayout}>
                                {getFieldDecorator('cusName', {
                                    initialValue: thirdIdName,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择客户名称'
                                        }
                                    ]
                                })(<Select style={{width: 400}} onChange={this.cusNameChange.bind(this)}
                                           disabled={this.props.params.id == 5 ? true : false}>
                                    {options1.map(function (cur, ind) {
                                        return <Option key={ind} value={cur.thirdId + ''}>{cur.name}</Option>;
                                    })}
                                </Select>)}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="购货单位" {...formItemLayout}>
                                {getFieldDecorator('PurchaseUnit', {
                                    initialValue: purchaseName,
                                    // rules: [
                                    // 	{
                                    // 		required: true,
                                    // 		message: '请选择购货单位'
                                    // 	}
                                    // ]
                                })(
                                    <div>
                                        <Input value={this.state.purchaseName}
                                               style={{width: 400, position: 'relative', zIndex: 1,}}
                                               onClick={this.searchHandler}/>
                                        <i className="anticon anticon-search" style={styleObj}
                                           onClick={this.searchHandler}></i>
                                    </div>
                                )}
                            </FormItem>
                        </Col>
                    </Row>


                    <Row>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="渠道" {...FormItemLayout}>
                                {getFieldDecorator('channel', {
                                    initialValue: value1,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择渠道'
                                        }
                                    ]
                                })(
                                    <RadioGroup onChange={this.onChangeChannel} setFieldsValue={this.state.value1}>
                                        {options2.map(function (item, key) {
                                                return <Radio key={key + ''} disabled
                                                              value={item.name + ''}>{item.name}</Radio>
                                            }
                                        )}
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="订单类型" {...formItemLayout}>
                                {getFieldDecorator('Type', {
                                    initialValue: 'Y' + xId,
                                    rules: [
                                        {
                                            required: true,
                                            message: '订单类型错误'
                                        }
                                    ]
                                })(
                                    <RadioGroup onChange={this.onChangeType}
                                                setFieldsValue={this.props.params.id == 4 ? '' : 'Y' + xId}
                                                disabled={disabledSet}>
                                        <Radio
                                            value={this.props.params.id == 4 || 5 ? 'Y1' : options3.ordinaryOrderFlag + '1'}
                                            style={{display: options3.ordinaryOrderFlag == 'Y' ? 'inline-block' : 'none'}}>常规订单权限</Radio>
                                        <Radio
                                            value={this.props.params.id == 4 || 5 ? 'Y2' : options3.terminalOrderFlag + '2'}
                                            style={{display: options3.terminalOrderFlag == 'Y' ? 'inline-block' : 'none'}}>项目订单权限</Radio>
                                        <Radio
                                            value={this.props.params.id == 4 || 5 ? 'Y3' : options3.vipOrderFlag + '3'}
                                            style={{display: options3.vipOrderFlag == 'Y' ? 'inline-block' : 'none'}}>合作伙伴订单权限</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                </Form>


            </div>

            <Modal
                visible={visible}
                title="选择购货单位"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <span style={{'color': 'red'}}>请输入购货单位再点查询按钮</span>
                        </Row>
                        <Row>
                            <Col span={10}><label>购货单位：</label><Select showSearch
                                                                           optionFilterProp="children"
                                                                           style={{width: 300}}
                                                                           value={this.state.name}
                                                                           filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                           onChange={this.nameChange}>
                                {channel_GouHuo.map(function (item, key) {
                                    return <Select.Option key={key + ''}
                                                          value={item.value + ''}>{item.text}</Select.Option>;
                                })}
                            </Select></Col>
                            <Col span={8}><label>授信方式：</label><Input style={{width: 200}} value={this.state.code}
                                                                         onChange={this.codeChange}/></Col>
                            <Col span={6}><Button onClick={this.getAlreadyArray}>搜索</Button></Col>
                        </Row>
                        <TableView {...alreadyProps} bordered style={{marginTop: 10}}
                                   onRowClick={this.onSelectRow.bind(this)}/>
                    </section>
                </div>
            </Modal>
        </div>
    }
}

export default Form.create()(ShoppingCarAdd);



// WEBPACK FOOTER //
// ./src/routes/shoppingCar/add.js